import styled, { css } from "styled-components";

interface PropsSanitaryPlan {
  selectedFile: boolean;
}

export const Container = styled.div`
  @media (min-width: 768px) {
    height: 100%;
    overflow-y: scroll;
  }
`;

export const SectionForm = styled.div`
  width: 100%;

  > p {
    font-size: 1rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const ContentButton = styled.div`
  max-width: 280px;
  width: 100%;
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  padding: 0;
  height: 100%;

  > div + div {
    margin-top: 2rem;
  }

  ${ContentButton} {
    margin-top: 3rem;
  }

  @media (min-width: 768px) {
    margin-top: 3rem;
    padding: 0 2rem;
  }
`;

export const FirstContentForm = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;

  > div {
    width: 100%;
  }

  > div + div {
    margin-top: 1rem;
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
      "name hectares"
      "areaDairyActivity mediumHerdSize"
      "typeProduction cnpj"
      "numberProducerRural routeDescription"
      "map image"
      "map image"
      "latlng city"
      "state country";
    gap: 20px;

    > div {
      & + div {
        margin-top: 0rem;
      }

      &:nth-child(1) {
        grid-area: name;
      }

      &:nth-child(2) {
        grid-area: hectares;
      }

      &:nth-child(3) {
        grid-area: areaDairyActivity;
      }

      &:nth-child(4) {
        grid-area: mediumHerdSize;
      }

      &:nth-child(5) {
        grid-area: typeProduction;
      }

      &:nth-child(6) {
        grid-area: cnpj;
      }

      &:nth-child(7) {
        grid-area: numberProducerRural;
      }

      &:nth-child(8) {
        grid-area: routeDescription;
      }

      &:nth-child(9) {
        grid-area: map;
      }

      &:nth-child(10) {
        grid-area: image;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      &:nth-child(11) {
        grid-area: latlng;
      }

      &:nth-child(12) {
        grid-area: city;
      }

      &:nth-child(13) {
        grid-area: state;
      }

      &:nth-child(14) {
        grid-area: country;
      }
    }
  }
`;

export const PictureProperty = styled.div``;

export const PicturePreview = styled.div`
  height: 180px;
  width: 100%;

  img {
    height: 180px;
    width: 100%;
    object-fit: cover;
  }

  @media (min-width: 768px) {
    width: 250px;

    img {
      width: 250px;
    }
  }
`;

export const NoPicturePreview = styled.div`
  ${({ theme }) => css`
    background-image: linear-gradient(
      to bottom,
      ${theme.colors.lightGray},
      ${theme.colors.lightGray} 45%
    );
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${theme.colors.white};
    height: 180px;
    width: 100%;

    svg {
      width: 30px;
      height: 30px;
      margin-bottom: 1rem;
    }

    p {
      font-size: 0.875rem;
    }

    @media (min-width: 768px) {
      width: 250px;
    }
  `}
`;

export const LatLng = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    width: 100%;

    & + div {
      margin-top: 1rem;
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;

    > div {
      width: 45%;

      & + div {
        margin-top: 0px;
      }
    }
  }
`;

export const ControlsUploadImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.5rem;
  cursor: pointer;

  div:nth-child(1) {
    box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
    padding: 0.5rem;
    font-size: 0.75rem;
    width: 130px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;

    label {
      cursor: pointer;
    }

    input {
      display: none;
    }
  }
`;

export const RemovePicture = styled.div`
  width: 30px;
  height: 30px;
  margin-left: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  cursor: pointer;
`;

export const SecondContentForm = styled.div`
  display: flex;
  flex-direction: column;

  > div + div {
    margin-top: 1rem;
  }

  @media (min-width: 768px) {
    flex-direction: row;

    > div + div {
      margin-top: 0rem;
      margin-left: 2rem;
    }
  }
`;

export const InputMap = styled.div`
  width: 100%;
  height: 220px;
  z-index: 0;

  > div {
    width: 100%;
    height: 100%;
  }
`;

export const UploadSanitaryPlan = styled.div<PropsSanitaryPlan>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-size: 0.875rem;

  svg {
    width: 22px;
    height: 22px;
    ${({ theme, selectedFile }) =>
      selectedFile &&
      css`
        color: ${theme.colors.orange};
      `}
  }

  label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0.5rem 1rem;
    cursor: pointer;
  }

  > input {
    display: none;
  }

  @media (min-width: 768px) {
    label {
      width: 210px;
    }
  }
`;
